import util from '@bmp-vue/core/api/util'

const controller = 'OperadorRetaguarda'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetInformacoesOperadorOfuscado: function () {
    return util.Axios.Get(controller + '/GetInformacoesOperadorOfuscado')
  },
})
